import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ChatDialogComponent } from '../ask-me-anything/chat-dialog/chat-dialog.component';

@Component({
  selector: 'app-dashboard-welcome-banner',
  standalone: true,
  imports: [CommonModule, FormsModule, ChatDialogComponent],
  templateUrl: './dashboard-welcome-banner.component.html',
  styleUrl: './dashboard-welcome-banner.component.scss'
})
export class DashboardWelcomeBannerComponent {
  @Input() firstName: string = '';
  @Input() isFirstTime: boolean = false;
  @ViewChild('chatDialog') chatDialog!: ChatDialogComponent;
  message: string = '';

  openChat(): void {
    if (this.chatDialog) {
      this.chatDialog.showDialog(this.message);
      this.message = ''; // Clear after sending
    }
  }
}
